// ---------- difficulty ----------
// Nothing on the backend says how hard a puzzle is, and no column is needed for it: the work a
// sheet asks for IS its size. The generator lets whoever builds it choose that size freely (see
// #gridn in index.html), so the scale reads the size back off the grid and names it — one place,
// used both by the catalogue's badges and filters and by the generator while the slider moves,
// so the word an author sees while cropping is the word a player reads on the card.
//
// Total cells rather than cells on the longer side: a 200 × 125 landscape and a 150 × 200
// portrait both call themselves "200" and differ by a fifth of the work, and now that the
// resolution is a free number the longer side no longer stands for a level.
//
// Where the cuts sit. The published catalogue holds sheets of ~7 500 and ~9 600 cells, then a
// dozen between ~25 000 and ~33 000, then one of 60 000 — the bounds are drawn in those two gaps
// so nothing already out there changes label. Inside that freedom they are placed where the
// change of pace actually is: a portrait crosses 15 000 cells at about 140 on its long side, and
// 40 000 at about 230, so "Intermédiaire" covers exactly the band an evening's sheet lives in.

export const DIFFICULTIES = [
  { upTo: 15_000, key: 'facile', label: 'Simple' },
  { upTo: 40_000, key: 'moyen', label: 'Intermédiaire' },
  { upTo: Infinity, key: 'avance', label: 'Avancé' },
] as const;

export type Difficulty = (typeof DIFFICULTIES)[number];

/** The level a grid of this size falls in. Never null: the last band has no ceiling, because the
 *  backend accepts grids larger than anything the generator is likely to be pushed to. */
export function gridDifficulty(gridW: number, gridH: number): Difficulty {
  const cells = gridW * gridH;
  return DIFFICULTIES.find((d) => cells <= d.upTo) ?? DIFFICULTIES[DIFFICULTIES.length - 1];
}

export function diffLabel(key: string): string {
  return DIFFICULTIES.find((d) => d.key === key)?.label ?? key;
}
